import React from 'react';

import { Stack } from '@mantine/core';
import { AthleteAppointmentMeta } from 'hooks/athleteAppointment/useAthleteAppointmentMeta';

import AthleteAppointmentStateLabel from './AthleteAppointmentStateLabel';
import AthleteAppointmentSupplementalText from './AthleteAppointmentSupplementalText';

interface AthleteAppointmentStateStackProps {
  athleteAppointmentMeta: AthleteAppointmentMeta;
  size?: 'md' | 'lg' | 'xl';
}

const AthleteAppointmentStateStack = ({
  athleteAppointmentMeta,
  size,
}: AthleteAppointmentStateStackProps): JSX.Element => {
  const supplementalSize = size === 'md' ? 'sm' : size === 'lg' ? 'md' : 'lg';
  return (
    <Stack spacing={4} align='center'>
      {athleteAppointmentMeta.stateText && (
        <AthleteAppointmentStateLabel athleteAppointmentMeta={athleteAppointmentMeta} size={size} />
      )}
      {athleteAppointmentMeta.supplementalText && (
        <AthleteAppointmentSupplementalText
          athleteAppointmentMeta={athleteAppointmentMeta}
          size={supplementalSize}
        />
      )}
    </Stack>
  );
};

export default AthleteAppointmentStateStack;
